import apiClient, { extractData } from "../api-client";

// In phiếu tự động — docs/plans/2026-10-26-in-phieu-tu-dong.md.
export const printJobApi = {
  // Chỉ admin (Cài đặt > Máy in). Nhân viên in qua trang QR (/in-phieu, publicApi).
  listAllStations() {
    return apiClient.get("/print-stations/all").then(extractData);
  },
  createStation(name) {
    return apiClient.post("/print-stations", { name }).then(extractData);
  },
  updateStation(id, payload) {
    return apiClient.patch(`/print-stations/${id}`, payload).then(extractData);
  },
  rotateKey(id) {
    return apiClient.post(`/print-stations/${id}/rotate-key`).then(extractData);
  },
  deleteStation(id) {
    return apiClient.delete(`/print-stations/${id}`).then(extractData);
  },
  testStation(id) {
    return apiClient.post(`/print-stations/${id}/test`).then(extractData);
  },
  rotateQr(id) {
    return apiClient.post(`/print-stations/${id}/rotate-qr`).then(extractData);
  },
  getNetwork() {
    return apiClient.get("/print-stations/network").then(extractData);
  },
  saveNetwork(payload) {
    return apiClient.put("/print-stations/network", payload).then(extractData);
  },
  listJobs(stationId) {
    return apiClient
      .get("/print-jobs", { params: stationId ? { station_id: stationId } : {} })
      .then(extractData);
  },
};

export default printJobApi;
